module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ill-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/illustrations#ill001"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb2",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre001"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb2",
    attrs: {
      "id": "abb-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb001"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocp1",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I. THINKING ABOUT BIBLICAL LAW")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1. Introduction: Water from Sinai")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2. The Laws in Scripture: Dates and Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_vm._v("3. Biblical Law: Mosaic or a Mosaic?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Approaches to the Law: Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocp2",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("II. ISRAEL AT THE HOLY MOUNTAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Ten Commandments: Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Second Commandment: Revealing the Nature of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "fur-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/further001#fur001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FURTHER READING")]), _vm._v(": The Decalogue")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocp3",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("III. ISRAEL IN THE VILLAGE ASSEMBLY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Covenant Code: Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Restoration or Revenge? The Case of the Goring Ox")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Bible and Slavery: Humanitarian Concerns")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "fur-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/further002#fur002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FURTHER READING")]), _vm._v(": The Covenant Code")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocp4",
    attrs: {
      "id": "pt-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part004#pt004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IV. ISRAEL IN THE COURTS OF THE LORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Priestly and Holiness Law: Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Tabernacle: A Palace in the Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Sacrifice: Communication and Community-Making")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Gift Offerings: Commitment and Belonging")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Hazards of the Holy Life 1: Debt Offerings")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Hazards of the Holy Life 2: Food, Death, Sex, and Birth")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Holiness Code: Crops, Tattoos, and Loving Your Neighbor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Jubilee: Utopia or Practicality?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "fur-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/further003#fur003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FURTHER READING")]), _vm._v(": Priestly and Holiness Writings")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocp5",
    attrs: {
      "id": "pt-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part005#pt005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("V. ISRAEL IN THE CITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Deuteronomy: Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Covenant Theology and Religious Intolerance: Israel and the Canaanites")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Revolution: Centralization of the Cult")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Justice at the Gates: Capital Crimes and Judicial Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Limits of Social Solidarity: Women in Deuteronomic Law")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "fur-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/further004#fur004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FURTHER READING")]), _vm._v(": Deuteronomy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "bm-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#bm001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary Observations")])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb2a",
    attrs: {
      "id": "bm-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter002#bm002",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb2",
    attrs: {
      "id": "ind-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#ind001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of Subjects")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb2",
    attrs: {
      "id": "ind-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#ind002",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of Scripture and Other Ancient Literature")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0